import { render, staticRenderFns } from "./IBMMQPdRes.vue?vue&type=template&id=1a7e8244&scoped=true&"
import script from "./IBMMQPdRes.vue?vue&type=script&lang=js&"
export * from "./IBMMQPdRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7e8244",
  null
  
)

export default component.exports